<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label="label" :placeholder="placeholder" :hint="hint" :hide-details="hideDetails" item-value="id" item-text="name" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter />
</template>

<script>
export default {

    name: `im-place-search`,

    props: {
        place: Object,
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean,
    },

    data() {
        return {
            model: {
                id: null,
                name: null
            },
            items: [],
            loading: false,
            search: null,
            search_timeout: 300,
            };
    },

    watch: {

        search(val) {
            if(this.model && val === this.model.name) {
                return;
            }

            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit("input", this.model);
        },

        place(val) {
            if(!val) {
                return
            }
            this.model = {
                id: val.id,
                name: val.name
            };

            if(val.id && val.name) {
            this.items = [this.model];
            } else {
            this.items = [];
            }
        }
    },


    methods: {
       getItems(val) {
         // quit early if no search value
         if (!val) {
           return;
         }

         // loading
         this.loading = true;

         // setup query endpoint
         let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
         let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/search";

         // prepare params
         let options = {
           params: {
             query: val,
             locale: "ro",
             size: 5,
             // country: "ro"
           }
         };

         // make places search request
         this.$axios.get(endpoint, options)
           .then(response => {
               this.items = response.data.data;
           })
           .catch(error => {
               console.log(error);
           })
           .finally(() => {
               this.loading = false;
           });
       },
       reset() {
            this.model = {
                id: null,
                name: null
            };
            this.search = null;
            this.items = [];
       }
     }
   };
   </script>
